$(document).ready(function () {
    if ($('.js-map').length > 0) {
        $('.js-map-itself')
            .gmap3({
                center: [53.26593547725956, -1.437275844847981],
                zoom: 17,
                navigationControl: false,
                scrollwheel: false,
                streetViewControl: false,
                mapTypeControl: false,
                zoomControl: false,
                fullscreenControl: false
            })
            .marker(
                [
                    {
                        position: [53.26592, -1.43729]
                    }
                ]
            );
    }

});